import React from "react";
import { Link } from "react-router-dom";
import { formatBlogDate } from "../data/blogPosts";

function BlogFeaturedPost({ post, imageBase }) {
  if (!post) return null;
  const img = `${imageBase}/${post.featuredImage}`;
  return (
    <article className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm ring-1 ring-slate-200/50">
      <div className="grid gap-0 md:grid-cols-12 md:items-stretch">
        <Link
          to={`/blog/${encodeURIComponent(post.slug)}`}
          className="relative aspect-[16/10] bg-slate-100 md:col-span-7 md:aspect-auto md:min-h-[280px]"
        >
          <img
            src={img}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            loading="eager"
            decoding="async"
          />
        </Link>
        <div className="flex flex-col justify-center p-6 md:col-span-5 md:p-8 lg:p-10">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Featured</p>
          <p className="mt-2 text-xs font-medium text-slate-600">{post.category}</p>
          <h2 className="mt-2 text-xl font-semibold leading-snug tracking-tight text-slate-900 md:text-2xl">
            <Link
              to={`/blog/${encodeURIComponent(post.slug)}`}
              className="transition hover:text-slate-700"
            >
              {post.title}
            </Link>
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-[15px]">{post.excerpt}</p>
          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
            <time dateTime={post.date}>{formatBlogDate(post.date)}</time>
            <span>{post.readTime}</span>
          </div>
          <div className="mt-6">
            <Link
              to={`/blog/${encodeURIComponent(post.slug)}`}
              className="inline-flex min-h-[40px] items-center justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 shadow-sm transition-colors hover:border-slate-400 hover:bg-slate-50"
            >
              Read article
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}

export default BlogFeaturedPost;
